import React, { FC, useState } from 'react';
import s from './PostButton.module.css';
import Button from '../button/Button';
import { useSelector } from 'react-redux';
import { selectSelectedSocialMedia } from '../../../store/selectors/projectSelectors';
import { CurrentProject } from '../../../shared/types/projectTypes';
import { PostModal } from '../post-modal/PostModal';
import { socialMediaOptions } from '../../constant/constant';
import { SocialConnections, UserAttributes } from '../../types/authTypes';
import { useNavigate } from 'react-router-dom';
import {
    selectIsFreeSubscription,
    selectPostsUsed,
    selectIsBasicSubscription,
} from '../../../store/selectors/subscriptionSelector';
import { setPricingModal } from '../../../store/slices/pageSlice';
import { useAppDispatch } from '../../../store/store';
import IconLock from '../icons/IconLock';

type PostButtonProps = {
    currentProject: CurrentProject | null;
    activeEditorMode: 'Visual' | 'Captions' | 'Review';
    user: UserAttributes | null;
    saveImage?: () => Promise<void>;
};
const PostButton: FC<PostButtonProps> = ({ currentProject, activeEditorMode, user, saveImage }) => {
    const [showPostModal, setShowPostModal] = useState(false);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const content_type = currentProject?.content_type;
    const userSocialConnections = user?.social_connections;
    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);
    const postsUsed = useSelector(selectPostsUsed);

    const isRestrictPostFreeUser = postsUsed > 0 && isFreeSubscription;

    const isRestrictPostBasicUser = postsUsed > 15 && isBasicSubscription;

    const isSocialMediaConnected = () => {
        if (!userSocialConnections || !content_type) return false;

        const connections =
            typeof userSocialConnections === 'string'
                ? JSON.parse(userSocialConnections)
                : userSocialConnections;

        return connections[content_type] !== null && connections[content_type] !== false;
    };

    const handleConnectSocialMedia = () => {
        navigate('/settings');
    };

    const handlePostNow = async () => {
        if (saveImage) {
            await saveImage();
        }
        if (isRestrictPostFreeUser || isRestrictPostBasicUser) {
            dispatch(setPricingModal(true));
        } else {
            setShowPostModal(true);
        }
    };

    return (
        <>
            {!isSocialMediaConnected() ? (
                <Button
                    text="Connect Social Media"
                    onClick={handleConnectSocialMedia}
                    state="enabled"
                    style={{
                        width: '200px',
                        fontWeight: '600',
                        backgroundColor: '#FFDD35',
                        color: '#000',
                    }}
                />
            ) : (
                <Button
                    text="Post now!"
                    onClick={handlePostNow}
                    icon={isRestrictPostFreeUser || isRestrictPostBasicUser ? <IconLock /> : null}
                    style={{
                        width: '130px',
                        fontWeight: '600',
                        backgroundColor: '#FFDD35',
                        color: '#000',
                    }}
                />
            )}
            <PostModal isOpen={showPostModal} onClose={() => setShowPostModal(false)} />
        </>
    );
};

export default PostButton;
